"use client";

import { Button } from "@/components/shadcn/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/shadcn/dialog";
import { useTranslations } from "next-intl";
import type { ComponentProps, ReactNode } from "react";
import {
    EducationRequestForm,
    SupporterApplicationForm,
} from "./support-forms";

type SupportDialogButtonProps = {
    kind: "support" | "request";
    children: ReactNode;
    className?: string;
    size?: ComponentProps<typeof Button>["size"];
    variant?: ComponentProps<typeof Button>["variant"];
};

export function SupportDialogButton({
    kind,
    children,
    className,
    size,
    variant,
}: SupportDialogButtonProps) {
    const t = useTranslations("support");

    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button className={className} size={size} variant={variant}>
                    {children}
                </Button>
            </DialogTrigger>
            <DialogContent className="max-h-[calc(100dvh-2rem)] overflow-y-auto sm:max-w-xl">
                <DialogHeader>
                    <DialogTitle>
                        {t(
                            kind === "support"
                                ? "supportAction"
                                : "requestAction",
                        )}
                    </DialogTitle>
                    <DialogDescription>
                        {t(
                            kind === "support"
                                ? "supportDialogDesc"
                                : "requestDialogDesc",
                        )}
                    </DialogDescription>
                </DialogHeader>
                {kind === "support" ? (
                    <SupporterApplicationForm />
                ) : (
                    <EducationRequestForm />
                )}
            </DialogContent>
        </Dialog>
    );
}
